// Glyphs exported from the Arena design. Paths are the Figma originals; colour
// comes from CSS so the same glyph works on lime, red and translucent chrome.
export function LinkGlyph({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8.70713 5.40731L9.64993 6.35012C11.4724 8.1726 11.4724 11.1273 9.64993 12.9498L9.41427 13.1855C7.5918 15.0079 4.63703 15.0079 2.81459 13.1855C0.99214 11.3631 0.99214 8.40827 2.81459 6.58583L3.7574 7.52867C2.45565 8.8304 2.45565 10.9409 3.7574 12.2427C5.05915 13.5444 7.16967 13.5444 8.47147 12.2427L8.70713 12.007C10.0089 10.7052 10.0089 8.59467 8.70713 7.29293L7.76433 6.35012L8.70713 5.40731ZM13.1855 9.41427L12.2427 8.47147C13.5444 7.16967 13.5444 5.05915 12.2427 3.7574C10.9409 2.45565 8.8304 2.45565 7.52867 3.7574L7.29293 3.9931C5.99119 5.29485 5.99119 7.4054 7.29293 8.70713L8.23573 9.64993L7.29293 10.5927L6.35012 9.64993C4.52767 7.82753 4.52767 4.87274 6.35012 3.05029L6.58583 2.81459C8.40827 0.99214 11.3631 0.99214 13.1855 2.81459C15.0079 4.63703 15.0079 7.5918 13.1855 9.41427Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function CopyGlyph({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4.66653 4V2C4.66653 1.63181 4.96501 1.33333 5.3332 1.33333H13.3332C13.7014 1.33333 13.9999 1.63181 13.9999 2V11.3333C13.9999 11.7015 13.7014 12 13.3332 12H11.3332V13.9994C11.3332 14.3679 11.0333 14.6667 10.662 14.6667H2.67111C2.30039 14.6667 2 14.3703 2 13.9994L2.00173 4.66725C2.0018 4.29874 2.30176 4 2.67295 4H4.66653ZM5.99987 4H11.3332V10.6667H12.6665V2.66667H5.99987V4ZM4.66653 7.33333V8.66667H8.66653V7.33333H4.66653ZM4.66653 10V11.3333H8.66653V10H4.66653Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function CrowdGlyph({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M13.3333 14.6667H2.66667V13.3333C2.66667 11.4924 4.15905 10 6 10H10C11.8409 10 13.3333 11.4924 13.3333 13.3333V14.6667ZM8 8.66667C5.79086 8.66667 4 6.8758 4 4.66667C4 2.45753 5.79086 0.666666 8 0.666666C10.2091 0.666666 12 2.45753 12 4.66667C12 6.8758 10.2091 8.66667 8 8.66667Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function TrendGlyph({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8.66666 8V13.3333H7.33333V8H2.66667L8 2.66667L13.3333 8H8.66666Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function CompassGlyph({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 11.5L16 8L12.5 17.0021L11 13L7 11.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function ChecklistGlyph({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M8.00008 6V9H5.00008V6H8.00008ZM3.00008 4V11H10.0001V4H3.00008ZM13.0001 4H21.0001V6H13.0001V4ZM13.0001 11H21.0001V13H13.0001V11ZM13.0001 18H21.0001V20H13.0001V18ZM10.7072 16.2071L9.29297 14.7929L6.00008 18.0858L4.20718 16.2929L2.79297 17.7071L6.00008 20.9142L10.7072 16.2071Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function ProfileGlyph({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function SettingsGlyph({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M2 12C2 11.0083 2.12034 10.0447 2.34718 9.12295C3.52062 9.22579 4.6792 8.6478 5.27245 7.6199C5.86584 6.59166 5.7358 5.3593 5.05416 4.4834C6.44384 3.20623 8.1354 2.2645 10.0083 1.79167C10.3717 2.90738 11.4214 3.71428 12.6595 3.71428C13.8976 3.71428 14.9474 2.90738 15.3108 1.79167C17.1836 2.2645 18.8752 3.20623 20.2649 4.4834C19.5832 5.3593 19.4532 6.59166 20.0466 7.6199C20.6398 8.6478 21.7984 9.22579 22.9719 9.12295C23.1987 10.0447 23.319 11.0083 23.319 12C23.319 12.9917 23.1987 13.9553 22.9719 14.8771C21.7984 14.7742 20.6398 15.3522 20.0466 16.3801C19.4532 17.4083 19.5832 18.6407 20.2649 19.5166C18.8752 20.7938 17.1836 21.7355 15.3108 22.2083C14.9474 21.0926 13.8976 20.2857 12.6595 20.2857C11.4214 20.2857 10.3717 21.0926 10.0083 22.2083C8.1354 21.7355 6.44384 20.7938 5.05416 19.5166C5.7358 18.6407 5.86584 17.4083 5.27245 16.3801C4.6792 15.3522 3.52062 14.7742 2.34718 14.8771C2.12034 13.9553 2 12.9917 2 12ZM12.6595 15.4286C14.5537 15.4286 16.0888 13.8934 16.0888 12C16.0888 10.1066 14.5537 8.57143 12.6595 8.57143C10.7653 8.57143 9.23023 10.1066 9.23023 12C9.23023 13.8934 10.7653 15.4286 12.6595 15.4286Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function PonsBadge() {
  return (
    <img
      src="/images/pons-badge.png"
      alt=""
      width={16}
      height={16}
      loading="lazy"
      decoding="async"
    />
  );
}
